import { render } from "./FileComponent.vue?vue&type=template&id=148a66c4&scoped=true"
import script from "./FileComponent.vue?vue&type=script&lang=js"
export * from "./FileComponent.vue?vue&type=script&lang=js"

import "./FileComponent.vue?vue&type=style&index=0&id=148a66c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148a66c4"]])

export default __exports__